import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function WestDesMoinesProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="West Des Moines"
      headingExtra="IA"
      introText="West Des Moines travelers — Jordan Creek corporate professionals, insurance and financial services executives, Dallas County families, and Des Moines metro business travelers — have several passport options. Here is how they compare, and why most West Des Moines residents choose a registered State Department courier rather than driving 4+ hours to the nearest passport agency in another state."
      options={options}
      emergencyDescription="Iowa has ZERO passport agencies — the state's 3.2M residents have no in-state emergency passport option whatsoever. The closest agency is Chicago (~330 miles via I-80/I-88, 5+ hours) or Minneapolis (~250 miles via I-35, 4 hours) — but Chicago's single agency already serves Illinois's 12.5M residents plus border-region demand from Indiana and Wisconsin. West Des Moines is the insurance and financial services hub of Iowa — corporate executives on short-notice international business travel cannot afford a 10+ hour round trip to Chicago's single agency. I-80 across Iowa faces winter blizzards and whiteout conditions (Nov–March) that close the interstate entirely — when I-80 is closed, West Des Moines is geographically severed from every passport agency in the country. I-35 to Minneapolis faces the same winter hazards with limited services along the rural Iowa-Minnesota corridor."
      disclaimerText="*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing."
    />
  );
}